export default "__VITE_ASSET__DCZax2FK__"